import React, { useEffect } from 'react'
import i18n from '../i18n';
import { useDispatch, useSelector } from 'react-redux';
import { switchLanguage } from '../features/translation-slice';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC<{className?: string, containerClassName?: string}> = ({className, containerClassName}) => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector((state: any) => state.traslation.language);
    const { t } = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(currentLanguage as ('fr' | 'en' | 'pt'));
    },[]);

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLanguage = e.target.value;
        dispatch(switchLanguage(selectedLanguage));
        i18n.changeLanguage(selectedLanguage as ('fr' | 'en' | 'pt'));
    };
    return null
    // return (
    //     <div className={`${containerClassName || 'flex items-center justify-center'}`}>
    //         <label className='mr-3 font-sans'>{t('select-language')}</label>
    //         <select 
    //             value={currentLanguage}
    //             onChange={handleLanguageChange} 
    //             className={`${className} border border-slate-300 mr-5 py-3 px-3 rounded-xl focus:border-slate-300 focus:outline-none`}
    //         >
    //             <option value="en">English</option>
    //             <option value="fr">French</option>
    //             <option value="pt">Portiguese</option>
    //         </select>
    //     </div>
    // )
}

export default LanguageSwitcher